module.exports = __webpack_public_path__ + "static/media/g-1-c.093e3423.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-1-c.jpg
// module id = 1126
// module chunks = 33